/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable */
import React from 'react';
import { generateUUID } from '../DateUtilities/DateUtilities';
import SVGComponent from '../SVGComponents/SVGComponents';

const findTarget = (arr, target, path = [], nestedLvl = 0) => {
  for (let i = 0; i < arr.length; i++) {
    const newPath = [...path];
    newPath.push(arr[i].id);

    if (
      arr[i].navTo === target ||
      (arr[i].hasAliases && arr[i].hasAliases.includes(target))
    ) {
      return newPath;
    }

    if (arr[i].hasChildren) {
      const result = findTarget(
        arr[i].children,
        target,
        newPath,
        nestedLvl + 1
      );
      if (result) {
        return result;
      }
    }
  }
};

export const getActivePath = (urlPath, expandLvl) => {
  return findTarget(navStructure, urlPath, expandLvl);
};

export const icons = {
  faCog: (
    <span className="sidebar-icon">
      <i
        className="fa fa-cog"
        aria-hidden="true"
        style={{ fontSize: '26px' }}
      ></i>
    </span>
  ),
  Iconinvoice: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-invoice" />
    </span>
  ),
  IconCMS: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-CMS" />
    </span>
  ),
  Iconmaintain: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-maintain" />
    </span>
  ),
  Icontasks: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-tasks" />
    </span>
  ),
  Icondisplay: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-display" />
    </span>
  ),
  Iconresearch: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-research" />
    </span>
  ),
  Iconchartbars: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-chart-bars" />
    </span>
  ),
  Iconsystem: (
    <span className="sidebar-icon">
      <SVGComponent iconName="Icon-system" />
    </span>
  ),
  faUniversity: (
    <span className="sidebar-icon">
      <i className="fa fa-university" aria-hidden="true"></i>
    </span>
  ),
  faUsdBars: (
    <span className="sidebar-icon double-icons">
      <i className="fa fa-usd" aria-hidden="true"></i>
      <i className="fa fa-bars" aria-hidden="true"></i>
    </span>
  ),
  faLineChart: (
    <span className="sidebar-icon">
      <i className="fa fa-line-chart" aria-hidden="true"></i>
    </span>
  ),
  faLock: (
    <span className="sidebar-icon">
      <i
        className="fa fa-lock"
        aria-hidden="true"
        style={{ fontSize: '28px' }}
      ></i>
    </span>
  ),
  faUsers: (
    <span className="sidebar-icon">
      <i className="fa fa-users" aria-hidden="true"></i>
    </span>
  ),
  faClipboard: (
    <span className="sidebar-icon">
      <i className="fa fa-clipboard" aria-hidden="true"></i>
    </span>
  ),
  faMoney: (
    <span className="sidebar-icon">
      <i className="fa fa-money" aria-hidden="true"></i>
    </span>
  ),
  faFileText: (
    <span className="sidebar-icon">
      <i className="fa fa-file-text" aria-hidden="true"></i>
    </span>
  ),
  faUsd: (
    <span className="sidebar-icon">
      <i className="fa fa-usd" aria-hidden="true"></i>
    </span>
  ),
  faCheck: (
    <span className="sidebar-icon">
      <i
        className="fa fa-check"
        aria-hidden="true"
        style={{ fontSize: '28px' }}
      ></i>
    </span>
  ),
  faUser: (
    <span className="sidebar-icon">
      <i className="fa fa-user" aria-hidden="true"></i>
    </span>
  ),
  faDesktop: (
    <span className="sidebar-icon">
      <i className="fa fa-desktop" aria-hidden="true"></i>
    </span>
  ),
  faClaim: (
    <span className="sidebar-icon">
      <i className="fa fa-external-link" aria-hidden="true"></i>
    </span>
  ),
  faHandshake: (
    <span className="sidebar-icon">
      <i className="fa fa-handshake-o" aria-hidden="true"></i>
    </span>
  ),
  faEmar: (
    <span className="sidebar-icon">
      <i
        className="fa fa-etsy"
        aria-hidden="true"
        style={{ fontSize: '16px' }}
      ></i>
    </span>
  ),
  faReporting: (
    <span className="sidebar-icon">
      <i class="fas fa-chart-bar" aria-hidden="true"></i>
    </span>
  ),
  faDollar: (
    <span className="sidebar-icon">
      <i class="fa fa-usd" aria-hidden="true"></i>
      <i
        class="fa fa-exchange"
        style={{
          fontSize: '13px',
          paddingTop: '3px',
        }}
        aria-hidden="true"
      ></i>
    </span>
  ),
  iconHelp: (
    <div className="sidebar-icon">
      <SVGComponent iconName="Icon-Help-Menu" />
    </div>
  ),
};

const dataToUrlParam = (rowData) => {
  const objStr = JSON.stringify(rowData);
  const toBase64 = btoa(objStr);
  return toBase64;
};

export const navStructure = [
  {
    value: 'Dashboard',
    navTo: '/dashboard',
    id: generateUUID(),
    hasChildren: false,
  },
  {
    value: 'Invoice',
    id: generateUUID(),
    icon: icons.Iconinvoice,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Request Drug Price Load',
        id: generateUUID(),
        navTo: '/RequestDrugPriceLoad',
        hasChildren: false,
      },
      {
        value: 'Request URA Calculation',
        id: generateUUID(),
        navTo: '/RequestURACalculation',
        hasChildren: false,
      },
      {
        value: 'Request Invoice Calculation',
        id: generateUUID(),
        navTo: '/requestInvoiceCalculation',
        hasChildren: false,
      },
      {
        value: 'Record Mailing Date',
        id: generateUUID(),
        navTo: '/recordMailingDate',
        hasChildren: false,
      },
      {
        value: 'Freeze Invoice',
        id: generateUUID(),
        navTo: '/freezeInvoice',
        hasChildren: false,
      },
      {
        value: 'Generate Invoices',
        id: generateUUID(),
        navTo: '/generateInvoice',
        hasChildren: false,
      },
      {
        value: 'Create Utilization File',
        id: generateUUID(),
        navTo: '/createUtilizationTape',
        hasChildren: false,
      },
    ],
  },
  {
    value: 'CMS',
    id: generateUUID(),
    icon: icons.IconCMS,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Maintain CMS Mat Drugs',
        id: generateUUID(),
        navTo: '/MaintainCMSMatDrugs',
        hasChildren: false,
      },
      {
        value: 'CMS Quarterly Reporting',
        id: generateUUID(),
        navTo: '/CMSQuarterlyReporting',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
    ],
  },
  {
    value: 'Tasks',
    id: generateUUID(),
    icon: icons.Icontasks,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Log Batch Totals',
        id: generateUUID(),
        navTo: '/logBatchSearch',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Create Letter',
        id: generateUUID(),
        navTo: '/createLetter',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Generate Collection Letter',
        id: generateUUID(),
        navTo: '/GenerateCollectionLetter',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Log Check',
        id: generateUUID(),
        navTo: '/log-check',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Allocate Payments',
        id: generateUUID(),
        navTo: '/allocatePayment',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Link New Drugs to Drug Families',
        id: generateUUID(),
        navTo: '/linknewdrugstodrugfamily',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Request Claim Audit',
        id: generateUUID(),
        navTo: '/RequestClaimAudit',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'View Check Allocations',
        id: generateUUID(),
        navTo: '/searchViewCheckAllocation',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'View Checks By Associated Invoices',
        id: generateUUID(),
        navTo: '/checksByInvoice',
        hasChildren: false,
      },
      {
        value: 'Assign Disputes',
        id: generateUUID(),
        navTo: '/assignDisputesSearch',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Perform Dispute Resolution ',
        id: generateUUID(),
        navTo: '/requestCurrentDisputeDisplay',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Record Provider Review',
        id: generateUUID(),
        navTo: '/providerReview',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Request Mailing Label',
        id: generateUUID(),
        navTo: '/MailingLabel',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Calculate Interest',
        id: generateUUID(),
        navTo: '/calculateInterest',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
    ],
  },
  {
    value: 'Maintain',
    id: generateUUID(),
    icon: icons.Iconmaintain,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'T-Bill Rates',
        id: generateUUID(),
        navTo: '/tBill',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Ineligible Providers',
        id: generateUUID(),
        navTo: '/ineligibleProviders',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Drug Family',
        id: generateUUID(),
        navTo: '/drugfamily',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Rebate Program',
        id: generateUUID(),
        navTo: '/SearchRebate',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Client',
        id: generateUUID(),
        navTo: '/client',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Group',
        id: generateUUID(),
        navTo: '/group',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Plan',
        id: generateUUID(),
        navTo: '/plan',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Unit Conversion',
        id: generateUUID(),
        navTo: '/unitConversion',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Manufacturer',
        id: generateUUID(),
        navTo: '/manufacturer',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Excluded NDCs ',
        id: generateUUID(),
        navTo: '/excludedNDCs',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Check',
        id: generateUUID(),
        navTo: '/check',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Letter Template',
        id: generateUUID(),
        navTo: '/letterTemplate',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Contract',
        id: generateUUID(),
        navTo: '/contract',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Rebate Price Level',
        id: generateUUID(),
        navTo: '/priceLevel',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Rebate Price Details ',
        id: generateUUID(),
        navTo: '/rebatePriceSearch',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Number of Units',
        id: generateUUID(),
        navTo: '/units-claim',
      },
    ],
  },
  {
    value: 'Display',
    id: generateUUID(),
    icon: icons.Icondisplay,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Provider',
        id: generateUUID(),
        navTo: '/provider',
        hasChildren: false,
      },
      {
        value: 'Invoice Details',
        id: generateUUID(),
        navTo: '/request-invoice-detail',
        hasChildren: false,
      },
      {
        value: 'NDC',
        id: generateUUID(),
        navTo: '/ndc',
        hasChildren: false,
      },
      {
        value: 'Claim',
        id: generateUUID(),
        navTo: '/claim',
      },
      {
        value: 'Checks',
        id: generateUUID(),
        navTo: '/checks',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Letter',
        id: generateUUID(),
        navTo: '/letter',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'View Calculated Interest',
        id: generateUUID(),
        navTo: '/view-calculated-interest',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'View Calculated URA',
        id: generateUUID(),
        navTo: '/ura-search',
      },
      {
        value: 'Invoice Reports',
        id: generateUUID(),
        navTo: '/request-invoice-report',
        hasChildren: false,
      },
    ],
  },
  {
    value: 'Research',
    id: generateUUID(),
    icon: icons.Iconresearch,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Account Receivable ',
        id: generateUUID(),
        navTo: '/reqAccReceivable',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Claim Audits ',
        id: generateUUID(),
        navTo: '/claimAuditSelect',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'CMS Mismatch',
        id: generateUUID(),
        navTo: '/cmsMismatch',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Labeler Differences',
        id: generateUUID(),
        navTo: '/labelerDifferences',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Invoice Audits',
        id: generateUUID(),
        navTo: '/invoiceAudits',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'CMS/ROSI Discrepancies',
        id: generateUUID(),
        navTo: '/cmsRosi',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'ROSI/PQAS Inconsistencies',
        id: generateUUID(),
        navTo: '/rosiInconsistencies',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Disputes',
        id: generateUUID(),
        navTo: '/disputes',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'CMS/Drug File Discrepancies',
        id: generateUUID(),
        navTo: '/cmsDrugFileDiscrepancies',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Contact Anomalies',
        id: generateUUID(),
        navTo: '/contactAnomalies',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Suspended Checks',
        id: generateUUID(),
        navTo: '/suspendedCheck',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },

      {
        value: 'Under Threshold Invoices',
        id: generateUUID(),
        navTo: '/underThresholdInvoice',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
    ],
  },
  {
    value: 'Summary Reports',
    id: generateUUID(),
    icon: icons.Iconchartbars,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Payment Summary',
        id: generateUUID(),
        navTo: '/paymentSummary',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },

      {
        value: 'Rebate Summary',
        id: generateUUID(),
        navTo: '/rebatesummary',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Rebate Percent of Spend',
        id: generateUUID(),
        navTo: '/percentSpend',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Invoice Register',
        id: generateUUID(),
        navTo: '/invoiceRegister',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },

      {
        value: 'Quarterly Payment',
        id: generateUUID(),
        navTo: '/quarterlyPayment1',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Invoices for Quarter not Paid',
        id: generateUUID(),
        navTo: '/reqInvoicesQtrnotPaid',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Top Balances',
        id: generateUUID(),
        navTo: '/topBalances',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Drug Type Summary',
        id: generateUUID(),
        navTo: '/drugTypeSummary',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Dispute Amounts',
        id: generateUUID(),
        navTo: '/disputeAmounts',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Dispute Activity',

        id: generateUUID(),

        navTo: '/disputeActivity',

        hasChildren: false,

        isFormDirty: false,

        isFormError: false,

        isFormSave: false,
      },
      {
        value: 'Dispute Codes',
        id: generateUUID(),
        navTo: '/disputeCodes',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
    ],
  },

  {
    value: 'Detail Reports',
    id: generateUUID(),
    icon: icons.Iconchartbars,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Unallocated Balance',
        id: generateUUID(),
        navTo: '/unallocatedBalance',
        hasChildren: false,
      },
      {
        value: 'Check Allocation Comparision',
        id: generateUUID(),
        navTo: '/checkallocationcomparison',
        hasChildren: false,
      },
      {
        value: 'Current Zero URA',
        id: generateUUID(),
        navTo: '/currentZeroURA',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'NDC Details',
        id: generateUUID(),
        navTo: '/ndcdetails',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'NDC History',
        id: generateUUID(),
        navTo: '/ndchistoryreport',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Contract',
        id: generateUUID(),
        navTo: '/contractreport',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Dispute Recapitulation',
        id: generateUUID(),
        navTo: '/disputeRecapitulation',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'HCPCS Code Claims Paid',
        id: generateUUID(),
        navTo: '/hcpcsCodeClaimsPaid',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Interest Override',
        id: generateUUID(),
        navTo: '/interestOverride',
        hasChildren: false,
      },
      {
        value: 'ROSI/PQAS',
        id: generateUUID(),
        navTo: '/rosi_pqas',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Manufacturer Summary',
        id: generateUUID(),
        navTo: '/manufacturerSummary',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Adjusted Claims',
        id: generateUUID(),
        navTo: '/adjustedClaims',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'MCO Claims',
        id: generateUUID(),
        navTo: '/mco_claims',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Provider Claim Listing',
        id: generateUUID(),
        navTo: '/providerClaimListing',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
    ],
  },
  {
    value: 'State Reports',
    id: generateUUID(),
    icon: icons.Iconchartbars,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Excluded Claims',
        id: generateUUID(),
        navTo: '/excludedClaims',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'CHIP/CSHCN Rates',
        id: generateUUID(),
        navTo: '/chipCshcnRates',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'CHIP/CSHCN Rate Audit',
        id: generateUUID(),
        navTo: '/chipCshcnRateAudit',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Zero URA',
        id: generateUUID(),
        navTo: '/zeroURA',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Interest Received',
        id: generateUUID(),
        navTo: '/interestRecieved',
        hasChildren: false,
      },
      {
        value: 'Outstanding Disputes After Num of Days',
        id: generateUUID(),
        navTo: '/outstandingDisputesForNumOfDays',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Outstanding Disputes for Quarter',
        id: generateUUID(),
        navTo: '/outstandingDisputesForQuarter',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Adjustment by Reason Code',
        id: generateUUID(),
        navTo: '/adjustmentByReasonCode',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Quarterly CMS UROA',
        id: generateUUID(),
        navTo: '/cmsUra',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Institutional Claim Unit Type Discrepancy',
        id: generateUUID(),
        navTo: '/institionalClaimsTypeDiscrepancy',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Quarterly CMS Drug',
        id: generateUUID(),
        navTo: '/cmsDrug',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: '340B Provider Claims',
        id: generateUUID(),
        navTo: '/340BProviderClaims',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },

      {
        value: 'Program And Eligibility Category ',
        id: generateUUID(),
        navTo: '/programAndEligibilityCategory',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Total Dollars Paid',
        id: generateUUID(),
        navTo: '/totaldollarspaid',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Pre-Invoice Unit Adjustment',
        id: generateUUID(),
        navTo: '/PreInvoiceUnitAdjustment',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Current to Previous Quarter Invoice Comparison',
        id: generateUUID(),
        navTo: '/currentToPreviousQuarterInvoiceComparison',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Cash Receipt Summary',
        id: generateUUID(),
        navTo: '/cashReceiptSummary',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'CMS Report Adjustment Detail',
        id: generateUUID(),
        navTo: '/cmsReportAdjustmentDetail',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Outstanding Balance By Labeler And Quarter',
        id: generateUUID(),
        navTo: '/outstandingBalanaceByLabererAndQuarter',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Manufacturer Outstanding Balance',
        id: generateUUID(),
        navTo: '/manufacturerOutstandingBalance',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'NDC Payment Report',
        id: generateUUID(),
        navTo: '/ndcPayment',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Family Planning Drugs Invoiced for Rebates',
        id: generateUUID(),
        navTo: '/familyPlanningDrugsInvoicedforRebates',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Family Planning Drugs Payment Received',
        id: generateUUID(),
        navTo: '/familyPlanningDrugsPaymentReceived',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Active Labeler',
        id: generateUUID(),
        navTo: '/activeLabeler',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Terminated Labeler',
        id: generateUUID(),
        navTo: '/terminatedlabeler',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Monthly Claims Reconciliation',
        id: generateUUID(),
        navTo: '/monthlyclaimsreconcilliation',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Quarterly Claims Reconciliation',
        id: generateUUID(),
        navTo: '/quarterlyclaimsreconcilliation',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Drugs Therapeutic Class',
        id: generateUUID(),
        navTo: '/drugsTherapeuticClass',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Supplemental Rates',
        id: generateUUID(),
        navTo: '/supplementalRates',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Unit Adjustment at NDC Level',
        id: generateUUID(),
        navTo: '/unitAdjustmentatNdcLevel',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Substance Abuse Drug Report',
        id: generateUUID(),
        navTo: '/substanceAbuseDrug',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
      {
        value: 'Rider Report',
        id: generateUUID(),
        navTo: '/rider',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
      },
    ],
  },
  {
    value: 'System',
    id: generateUUID(),
    icon: icons.Iconsystem,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Comments and Correspondence',
        id: generateUUID(),
        navTo: '/comment',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'User Default',
        id: generateUUID(),
        navTo: '/userDefault',
        hasChildren: false,
      },
      {
        value: 'Code Tables',
        id: generateUUID(),
        navTo: '/codeTable',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Contact Type',
        id: generateUUID(),
        navTo: '/contactType',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Procedure Results',
        id: generateUUID(),
        navTo: '/ProcedureResults',
        hasChildren: false,
      },
      {
        value: 'Price Type',
        id: generateUUID(),
        navTo: '/priceType',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'Reminder Recipients',
        id: generateUUID(),
        navTo: '/reminderRecipients',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'System Reminders',
        id: generateUUID(),
        navTo: '/systemReminders',
        hasChildren: false,
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      },
      {
        value: 'System Parameter',
        id: generateUUID(),
        navTo: '/systemparameter',
        hasChildren: false,
      },
      {
        value: 'Technical Window',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/technicalWindow',
      },
      {
        value: 'Claim Grouping Parameter',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/claimGroupingParameter',
      },
      {
        value: 'User List',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/userList',
      },
      {
        value: 'Event Logging',
        id: generateUUID(),
        navTo: '/EventLogging',
        hasChildren: false,
      },
    ],
  },
  {
    value: 'Help',
    id: generateUUID(),
    icon: icons.iconHelp,
    privilegesNeeded: 'FssAdminUser',
    hasChildren: true,
    expanded: false,
    children: [
      {
        value: 'Help Index',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/dashboard',
      },
      {
        value: 'Release Notes',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/dashboard',
      },
      {
        value: 'About',
        id: generateUUID(),
        hasChildren: false,
        navTo: '/about',
      },
    ],
  },
];

export const helpObj = {
  name: 'Help',
  icon: '',
  readOnly: false,
  rootUrl: '',
  children: [
    {
      name: 'Help Index',
      url: '',
      previledges: null,
      readOnly: false,
      children: [],
    },
    {
      name: 'Release Notes',
      url: '',
      previledges: null,
      readOnly: false,
      children: [],
    },
    {
      name: 'About',
      url: '/about',
      previledges: null,
      readOnly: false,
      children: [],
    },
  ],
};
